/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cat_generators_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generators & Media`)
};

const es_cat_generators_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generadores y medios`)
};

const de_cat_generators_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatoren & Medien`)
};

const nl_cat_generators_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generators & Media`)
};

const fr_cat_generators_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateurs et médias`)
};

const it_cat_generators_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatori & Media`)
};

const pt_br2_cat_generators_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geradores e Mídia`)
};

const pt_cat_generators_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geradores e Multimédia`)
};

const ja_cat_generators_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジェネレーター・メディア`)
};

const zh_cat_generators_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成器与媒体`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cat_generators_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cat_generators_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cat_generators_name", locale)
	if (locale === "en") return en_cat_generators_name(inputs)
	if (locale === "es") return es_cat_generators_name(inputs)
	if (locale === "de") return de_cat_generators_name(inputs)
	if (locale === "nl") return nl_cat_generators_name(inputs)
	if (locale === "fr") return fr_cat_generators_name(inputs)
	if (locale === "it") return it_cat_generators_name(inputs)
	if (locale === "pt-BR") return pt_br2_cat_generators_name(inputs)
	if (locale === "pt") return pt_cat_generators_name(inputs)
	if (locale === "ja") return ja_cat_generators_name(inputs)
	return zh_cat_generators_name(inputs)
};